const ApiProxy = require("../ApiProxy");
const constants = require("../Domain/constants");
const AuthConfig = constants.SERVICE_AUTH;
const SlsHost = constants.slsApi.host;
const SlsHost2 = constants.slsApi.host2;
const { docClientFactory } = require("../../rev-aws-client/generic/dynamo");
const awsDocClient = docClientFactory({ url: `${SlsHost}/dynamo` });

module.exports = {
  async getJwt(token) {
    let resp = await ApiProxy.get({
      path: `${AuthConfig.host}/jwt/encode?token=${token}&client_id=${
        AuthConfig.clientId
      }&identity_api=${encodeURIComponent(AuthConfig.identityApi)}`,
      withHost: true
    });
    return resp;
  },

  async getCouponList() {
    let resp = await ApiProxy.get({
      // note: it is monoToken rather than jwt
      path: `${SlsHost2}/coupon?token=${ApiProxy.apiToken}`,
      withHost: true
    });
    return resp;
  },

  async createCoupon(data) {
    let resp = await ApiProxy.post({
      // note: it is monoToken rather than jwt
      path: `${SlsHost2}/coupon/create?token=${ApiProxy.apiToken}`,
      withHost: true,
      data: {
        name: data.name,
        value: data.value,
        deadline: data.deadline // unix-timestamp
      }
    });
    return resp;
  },

  async updateCoupon(id, data) {
    let resp = await ApiProxy.put({
      // note: it is monoToken rather than jwt
      path: `${SlsHost2}/coupon/${id}/edit?token=${ApiProxy.apiToken}`,
      withHost: true,
      data: {
        name: data.name,
        deadline: data.deadline // unix-timestamp
      }
    });
    return resp;
  },

  async deleteCoupon(id) {
    let resp = await ApiProxy.delete({
      // note: it is monoToken rather than jwt
      path: `${SlsHost2}/coupon/${id}/delete?token=${ApiProxy.apiToken}`,
      withHost: true
    });
    return resp;
  },

  async getInvitationCode() {
    let inviteCodeResp = await ApiProxy.get({
      path: `${SlsHost2}/invitation/self?token=${ApiProxy.jwtToken}`,
      withHost: true
    });
    return inviteCodeResp;
  },

  async getCreditRecord() {
    let recordResp = await ApiProxy.get({
      path: `${SlsHost2}/invitation/record?token=${ApiProxy.jwtToken}`,
      withHost: true
    });
    return recordResp;
  },

  async redeemCouponCode(code) {
    return ApiProxy.post({
      path: `${SlsHost2}/coupon/${code}/use?token=${ApiProxy.jwtToken}`,
      withHost: true
    });
  },

  async getMyProfile() {
    let profile = await ApiProxy.get({
      path: `${SlsHost}/signin?token=${ApiProxy.apiToken}`,
      withHost: true
    });

    // TODO: dynamoDB remote user should also support similar data structure of local user
    if (profile) {
      profile = {
        ...profile,
        user: { username: "" },
        social_avatar: "sls-fake",
        avatar: "sls-fake",
        phone: "",
        data: ""
      };
    }
    return profile;
  },

  async editMyProfile(meta) {
    // TODO: dynamoDB remote user should also support similar data structure of local user
    // TODO: if avatar exists, upload to s3! and then update other data in dynamoDB
    // should create sls edit profile api
    // TODO: merge to master!!!

    for (let key in meta) {
      if (meta[key] === "") {
        delete meta[key];
      }
    }

    let tokenType = "remote";
    console.log("update my remote file!");
    let profile = await ApiProxy.get({
      path: `${SlsHost}/signin?token=${ApiProxy.apiToken}`,
      withHost: true
    });
    const USER_TABLE = constants.aws.tableUser;
    let updatedProfile = {
      ...profile,
      // dynamoDB dis-allow empty string here
      meta: {
        ...meta
      }
    };
    let resp = await awsDocClient.put(
      {
        TableName: USER_TABLE, //TODO: master branch, extract to config
        Item: updatedProfile
      },
      { token: ApiProxy.apiToken, token_type: tokenType }
    );
    return updatedProfile;
  },

  async postInviteCode(code) {
    let resp = await ApiProxy.post({
      path: `${SlsHost2}/invitation/${code}/invite?token=${ApiProxy.jwtToken}`,
      withHost: true,
      data: {}
    });
    return resp;
  },

  async getCart() {
    let resp = await ApiProxy.get({
      path: `${SlsHost2}/cart?token=${ApiProxy.jwtToken}`,
      withHost: true
    });
    return resp;
  },

  async editCartConfig(config) {
    return ApiProxy.put({
      path: `${SlsHost2}/cart?token=${ApiProxy.jwtToken}`,
      withHost: true,
      data: { config }
    });
  },

  async promoCodeCheck(code) {
    return ApiProxy.post({
      path: `${SlsHost2}/order/check?token=${ApiProxy.jwtToken}`,
      withHost: true,
      data: { promo_code: code }
    });
  },

  async addItemToCart({ product, quantity }) {
    let resp = await ApiProxy.post({
      path: `${SlsHost2}/cart/add?token=${ApiProxy.jwtToken}`,
      data: { product, quantity },
      withHost: true
    });
    return resp;
  },

  async removeItemFromCart(index) {
    return ApiProxy.post({
      path: `${SlsHost2}/cart/remove?token=${ApiProxy.jwtToken}`,
      data: { index },
      withHost: true
    });
  },

  async editItemFromCart({ index, config: { product, quantity } }) {
    return ApiProxy.post({
      path: `${SlsHost2}/cart/edit?token=${ApiProxy.jwtToken}`,
      data: { index, config: { product, quantity } },
      withHost: true
    });
  },

  async listOrders({ userId }) {
    let resp = await awsDocClient.query(
      {
        TableName: constants.aws.tableOrder,
        IndexName: `buyer-index`,
        KeyConditionExpression: `buyer = :v1`,
        ExpressionAttributeValues: {
          ":v1": `${userId}`
        }
      },
      { token: ApiProxy.apiToken }
    );

    return resp.Items;
  },

  async adminListOrder({ from, to }) {
    function _unifyDateString(date) {
      let _year = date.getFullYear();
      let _month =
        date.getMonth() + 1 > 9
          ? `${date.getMonth() + 1}`
          : `0${date.getMonth() + 1}`;
      let _date =
        date.getDate() > 9 ? `${date.getDate()}` : `0${date.getDate()}`;
      return `${_year}-${_month}-${_date}`;
    }
    let _todayDate = new Date();
    let _todayDateString = _unifyDateString(_todayDate);
    // created time format is ISO-8601
    // from = '2020-03-01';
    // to = '2020-03-06'
    // covert local from, to date string to ISO string,
    // because we save `order.created` as ISO string, so we need to compute timezone offset.
    let baseQueryConfig = {
      // without from to
      TableName: constants.aws.tableOrder,
      IndexName: `currency-created-index`,
      KeyConditionExpression: `#s = :v1`,
      ExpressionAttributeNames: { "#s": "currency" },
      ExpressionAttributeValues: {
        ":v1": `TWD`
      }
    };
    let getTimeIntervalQueryConfig = ({ utcFromDate, utcToDate }) => {
      return {
        TableName: constants.aws.tableOrder,
        IndexName: `currency-created-index`,
        KeyConditionExpression: `#s = :v1 and #c BETWEEN :v2 and :v3`,
        ExpressionAttributeNames: { "#s": "currency", "#c": "created" },
        ExpressionAttributeValues: {
          ":v1": `TWD`,
          ":v2": utcFromDate.toISOString(),
          ":v3": utcToDate.toISOString()
        }
      };
    };

    let _utcFromDate = null;
    let _utcToDate = null;
    let queryConfig = baseQueryConfig;
    if (!from || !to) {
      queryConfig = baseQueryConfig;
    } else if (from === to) {
      _utcFromDate = new Date(
        new Date(from).getTime() + new Date().getTimezoneOffset() * 60 * 1000
      );
      _utcToDate = new Date(
        new Date(from).getTime() + new Date().getTimezoneOffset() * 60 * 1000
      );
      // toDate should be the end of the day
      _utcToDate = new Date(_utcToDate.setDate(_utcToDate.getDate() + 1));
      queryConfig = getTimeIntervalQueryConfig({
        utcFromDate: _utcFromDate,
        utcToDate: _utcToDate
      });
    } else {
      _utcFromDate = new Date(
        new Date(from).getTime() + new Date().getTimezoneOffset() * 60 * 1000
      );
      _utcToDate = new Date(
        new Date(to).getTime() + new Date().getTimezoneOffset() * 60 * 1000
      );
      if (to === _todayDateString) {
        // toDate should be the end of the day
        _utcToDate = new Date(_utcToDate.setDate(_utcToDate.getDate() + 1));
      }
      queryConfig = getTimeIntervalQueryConfig({
        utcFromDate: _utcFromDate,
        utcToDate: _utcToDate
      });
    }

    let resp = await awsDocClient.query(queryConfig, {
      token: ApiProxy.apiToken,
      token_type: "local"
    });

    return resp.Items;
  },

  async listStoreOrder({ store, tokenType, from, to }) {
    // TODO: should pass query date in awsDocClient.query, rather than filter after query returned
    let resp = await awsDocClient.query(
      {
        TableName: constants.aws.tableStoreOrder,
        IndexName: `store-index`,
        KeyConditionExpression: `#s = :v1`,
        ExpressionAttributeNames: { "#s": "store" },
        ExpressionAttributeValues: {
          ":v1": `${store}`
        }
      },
      { token: ApiProxy.apiToken, token_type: tokenType }
    );

    let items = resp.Items;

    // from, to format: '2019-09-12'
    items = items.filter(item => {
      let itemCreatedDate = new Date(item.created);
      if (from && from === to) {
        let itemCreatedYear = itemCreatedDate.getFullYear();
        let itemCreateMonth = (
          "00" + `${itemCreatedDate.getMonth() + 1}`
        ).slice(-2);
        let itemCreateDay = ("00" + `${itemCreatedDate.getDate()}`).slice(-2);

        return (
          `${itemCreatedYear}-${itemCreateMonth}-${itemCreateDay}` === from
        );
      }

      let localTimezoneOffset = new Date().getTimezoneOffset() * 60 * 1000;
      let itemCreatedTimestamp = itemCreatedDate.getTime();

      if (from) {
        let fromTimestamp = new Date(from).getTime() - localTimezoneOffset;

        if (itemCreatedTimestamp < fromTimestamp) {
          return false;
        }

        if (to) {
          let itemCreatedDateFormat = `
          ${itemCreatedDate.getFullYear()}-${(
            "00" +
            (itemCreatedDate.getMonth() + 1)
          ).slice(-2)}-${("00" + itemCreatedDate.getDate()).slice(-2)}`;

          if (itemCreatedDateFormat === to) {
            return true;
          } else {
            let toTimestamp = new Date(to).getTime() - localTimezoneOffset;
            if (itemCreatedTimestamp > toTimestamp) {
              return false;
            }
          }
        }
      }
      return true;
    });

    return items;
  },

  async createOrder(data) {
    let resultData = {
      ...data,
      payment_type: data.paymentType,
      promo_code: data.promoCode
    };
    console.log("result data", resultData);
    delete resultData.paymentType;
    delete resultData.promoCode;
    return ApiProxy.post({
      path: `${SlsHost2}/order/create?token=${ApiProxy.jwtToken}`,
      data: resultData,
      withHost: true
    });
  },

  async getOrderList() {
    return ApiProxy.get({
      path: `${SlsHost}/orders/?token=${ApiProxy.apiToken}`,
      withHost: true
    });
  },

  async getOrder(id) {
    let profile = await ApiProxy.get({
      path: `${SlsHost}/signin?token=${ApiProxy.apiToken}`,
      withHost: true
    });

    console.log("profile in get order by id:", profile);
    let resp = await awsDocClient.query(
      {
        TableName: constants.aws.tableOrder,
        IndexName: `buyer-index`,
        KeyConditionExpression: `buyer = :v1`,
        ExpressionAttributeValues: {
          ":v1": `${profile.id}`
        }
      },
      { token: ApiProxy.apiToken }
    );

    let order = resp.Items.find(item => item.id === id);

    return order || Promise.reject({ status: 404 });
  },

  async getStoreOrderByOrderId(id) {
    let resp = await awsDocClient.query(
      {
        TableName: constants.aws.tableStoreOrder,
        IndexName: `order_id-index`,
        KeyConditionExpression: `order_id = :v1`,
        ExpressionAttributeValues: {
          ":v1": `${id}`
        }
      },
      { token: ApiProxy.apiToken }
    );

    return resp.Items.length > 0 ? resp.Items : Promise.reject({ status: 404 });
  },

  async updateStoreOrder(id, data) {
    let { Item: storeOrderBeforeUpdate } = await awsDocClient.get(
      {
        TableName: constants.aws.tableStoreOrder,
        Key: {
          id
        }
      },
      { token: ApiProxy.apiToken, token_type: "local" }
    );

    if (!storeOrderBeforeUpdate) {
      return Promise.reject({ status: 404 });
    }
    let udpatedItem = { ...storeOrderBeforeUpdate, ...data };
    let resp = await awsDocClient.put(
      {
        TableName: constants.aws.tableStoreOrder,
        Item: udpatedItem
      },
      { token: ApiProxy.apiToken, token_type: "local" }
    );
    return udpatedItem;
  }
};
